import React, { useState, useRef, useEffect, useCallback } from 'react';
import styles from './HomeCardEmpty.scss';
import IHome from '../interfaces/IHome';
import Config from '../utils/Config';

const baseUrl = Config.get('baseUrl');

export interface IHomeCardEmptyProps {
    data?: IHome;
    view?: 'map' | 'list';
}
const HomeCardEmpty: React.FC<React.PropsWithChildren<IHomeCardEmptyProps>> = ({ data: home = {}, view = 'list' }) => {
    const detailUrl = baseUrl + '/property/' + home.id;

    let typeAndLocationText = `${home.propertyTypeText ? home.propertyTypeText : home.propertyType || ''} ${
        home.propertyTypeText && home.propertyType ? ' in ' : ''
    } ${home.locationText || ''}`;

    return (
        <div id={`homeCard${home ? home.id : null}`} className={styles.homeCardEmpty + ' ' + styles[view]}>
            <div className={styles.image} />
            <a href={detailUrl}>{typeAndLocationText}</a>
        </div>
    );
};

export default HomeCardEmpty;
